export class ReadMoreFilterButton {
    defaultMoreHtml = '<div class="show-more close"><span>Подробный фильтр</span><img src="/assets/images/ico/arrow.svg" alt=""/></div>';
    defaultLessHtml = '<div class="show-more open"><span>Простой фильтр</span><img src="/assets/images/ico/arrow.svg" alt=""/></div>';
    $moreHtml;
    $lessHtml;
    $container;
    $elements;
    initialized = false;
    windowWidth = 0;

    constructor(selector, moreHtml, lessHtml) {
        this.$container = $(selector);
        this.$moreHtml = $(moreHtml || this.defaultMoreHtml);
        this.$lessHtml = $(lessHtml || this.defaultLessHtml);
        this.$elements = $('> *', this.$container);
        this.windowWidth = window.innerWidth;
        if (this.$container.length) {
            this.checkState();

            $(window).on('resize', () => {
                if (this.windowWidth !== window.innerWidth) {
                    this.windowWidth = window.innerWidth;
                    this.checkState();
                }
            })
        } else {
            console.warn('ReadMoreFilterButton: container not found');
        }
    }

    checkState() {
        let containerEndHeight = this.$container.offset().top + this.$container.outerHeight();
        for (let i = 0; i < this.$elements.length; i++) {
            let $el = $(this.$elements[i]);
            if ($el.offset().top > containerEndHeight) {
                this.initialize();
                return;
            }
        }
        this.terminate();
    }

    initialize() {
        if (this.initialized === false) {
            this.initialized = true;
            this.$container.after(this.$moreHtml);
            this.$container.after(this.$lessHtml);
            this.$moreHtml.show();
            this.$lessHtml.hide();
            this.$moreHtml.on('click', (e) => {
                e.preventDefault();
                this.$moreHtml.hide();
                this.$lessHtml.show();
                this.$container.css({
                    'height': 'unset',
                    'max-height': 'unset'
                })
            });
            this.$lessHtml.on('click', (e) => {
                e.preventDefault();
                this.$moreHtml.show();
                this.$lessHtml.hide();
                this.clearContainerCss();
            });
        }
    }

    terminate() {
        if (this.initialized) {
            this.$moreHtml.off('click');
            this.$lessHtml.off('click');
            $(this.$moreHtml, this.$container).remove();
            $(this.$lessHtml, this.$container).remove();
            this.clearContainerCss();
            this.initialized = false;
        }
    }

    clearContainerCss() {
        this.$container.css({
            'height': '',
            'max-height': ''
        })
    }

}
